/* Black November — escada de desconto na página de produto.

   O que faz: ao escolher um degrau, escreve a quantidade no campo que já existe
   no bloco de comprar e deixa o botão de sempre fazer o resto. Nenhuma chamada
   de carrinho acontece aqui.

   Também recalcula os preços quando o cliente troca de variante: nesta loja as
   variantes de um modelo custam o mesmo, mas isso é coincidência de catálogo e
   não uma garantia — sem o recálculo, uma variante mais cara deixaria um preço
   errado na tela.

   Idempotente: o tema re-renderiza pedaços da página e dispara os próprios
   eventos, então init() pode rodar várias vezes sem duplicar listener. */
(function () {
  'use strict';

  // Guarda contra reentrada: addToCartJSON dispara o MESMO evento que estamos
  // escutando. Hoje ele manda {json, target} no detail, sem 'form', então o
  // handler já sairia pela checagem de form — isto é defesa em profundidade,
  // caso uma versão futura do tema passe a incluir o form.
  var bypass = false;

  function money(cents) {
    var raw = (typeof window.EthosFormatMoney === 'function')
      ? window.EthosFormatMoney(cents)
      // Fallback só para o caso de o cart-extras.js não ter carregado ainda.
      : 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    // O money_format desta loja é "<span class=money>R$ {{amount}} </span>" — vem
    // com HTML dentro. No Liquid isso é resolvido com | strip_html; aqui o texto
    // vai para textContent, então sem limpar as tags elas apareceriam na tela
    // como texto literal.
    return raw.replace(/<[^>]*>/g, '').trim();
  }

  function num(el, attr) {
    return parseInt(el.getAttribute(attr) || '0', 10) || 0;
  }

  function pctFor(root, qty) {
    var t1q = num(root, 'data-t1-qty');
    var t1p = num(root, 'data-t1-pct');
    var t2q = num(root, 'data-t2-qty');
    var t2p = num(root, 'data-t2-pct');
    if (t2q > t1q && qty >= t2q) return t2p;
    if (t1q > 0 && qty >= t1q) return t1p;
    return 0;
  }

  /* Mesma conta do Liquid, na mesma ordem, para o JS não mostrar um centavo
     diferente do que veio renderizado do servidor. */
  function tierMath(unit, qty, pct) {
    var gross = unit * qty;
    var disc = Math.floor(gross * pct / 100);
    var final = gross - disc;
    return { gross: gross, disc: disc, final: final, each: Math.floor(final / qty) };
  }

  function unitPriceOf(root) {
    var fallback = num(root, 'data-unit');
    var form = root.closest('form');
    if (!form) return fallback;
    var vinput = form.querySelector('[data-bstr-variant-input]');
    if (!vinput || !vinput.value) return fallback;
    var map;
    try { map = JSON.parse(root.getAttribute('data-prices') || '{}'); } catch (e) { return fallback; }
    var p = map[String(vinput.value)];
    return typeof p === 'number' ? p : fallback;
  }

  /* Soma as unidades do combo pelas cores escolhidas. Enquanto o cliente não
     mexe nos seletores todas valem a cor da página, então isso dá o mesmo
     resultado que unit * qty — mas passa a divergir, corretamente, assim que
     ele escolhe uma cor de preço diferente. */
  function grossFor(root, qty) {
    var unit = unitPriceOf(root);
    var selects = root.querySelectorAll('[data-cx-bn-pick-select]');
    if (!selects.length) return unit * qty;
    var map;
    try { map = JSON.parse(root.getAttribute('data-prices') || '{}'); } catch (e) { return unit * qty; }
    var total = 0;
    for (var i = 0; i < qty; i++) {
      var sel = selects[i];
      var p = sel ? map[String(sel.value)] : undefined;
      total += (typeof p === 'number') ? p : unit;
    }
    return total;
  }

  function repaint(root) {
    var unit = unitPriceOf(root);
    var tiers = root.querySelectorAll('[data-cx-bn-tier]');
    for (var i = 0; i < tiers.length; i++) {
      var tier = tiers[i];
      var qty = num(tier, 'data-qty');
      if (!qty) continue;

      var pct = pctFor(root, qty);
      var gross = tier.classList.contains('is-selected') ? grossFor(root, qty) : unit * qty;
      var disc = Math.floor(gross * pct / 100);
      var final = gross - disc;

      var total = tier.querySelector('[data-cx-bn-total]');
      if (total) total.textContent = money(final);

      // Preço por unidade no lugar do riscado: é o número que o cliente compara
      // de cabeça com o preço de uma unidade só.
      var each = tier.querySelector('[data-cx-bn-each]');
      if (each) each.textContent = qty > 1 ? money(Math.floor(final / qty)) + ' cada' : '';
    }
  }

  /* Mostra uma linha de cor por unidade do combo escolhido. Com 1 unidade o
     painel some: aí quem manda é o swatch da própria página, e duas formas de
     escolher a mesma cor confundiriam. */
  function syncPicker(root, qty) {
    var pick = root.querySelector('[data-cx-bn-pick]');
    if (!pick) return;
    var rows = pick.querySelectorAll('[data-cx-bn-pick-row]');
    var visiveis = 0;
    for (var i = 0; i < rows.length; i++) {
      var mostra = qty > 1 && (i + 1) <= qty;
      rows[i].hidden = !mostra;
      if (mostra) visiveis++;
    }
    pick.hidden = visiveis === 0;
  }

  /* A primeira linha segue o swatch da página: se o cliente troca a cor lá em
     cima depois de escolher o combo, o combo não pode ficar com a cor antiga. */
  function syncFirstRowToSwatch(root) {
    var form = root.closest('form');
    var vinput = form && form.querySelector('[data-bstr-variant-input]');
    var first = root.querySelector('[data-cx-bn-pick-select]');
    if (!vinput || !first || !vinput.value) return;
    var tem = false;
    for (var i = 0; i < first.options.length; i++) {
      if (first.options[i].value === String(vinput.value)) { tem = true; break; }
    }
    if (tem) first.value = String(vinput.value);
  }

  /* Itens que vão para o carrinho: uma linha por cor, com as repetições
     agrupadas em quantity. */
  function comboItems(root) {
    var tier = root.querySelector('[data-cx-bn-tier].is-selected') ||
               root.querySelector('.cx-bn-card__input:checked');
    if (tier && tier.closest) tier = tier.closest('[data-cx-bn-tier]');
    var qty = tier ? num(tier, 'data-qty') : 0;
    if (qty < 2) return null;

    var selects = root.querySelectorAll('[data-cx-bn-pick-select]');
    var form = root.closest('form');
    var vinput = form && form.querySelector('[data-bstr-variant-input]');
    var fallback = vinput && vinput.value ? parseInt(vinput.value, 10) : 0;

    var contagem = {};
    var ordem = [];
    for (var i = 0; i < qty; i++) {
      var id = selects[i] ? parseInt(selects[i].value, 10) : fallback;
      if (!id) return null;
      if (!contagem[id]) { contagem[id] = 0; ordem.push(id); }
      contagem[id]++;
    }
    return ordem.map(function (id) { return { id: id, quantity: contagem[id] }; });
  }

  /* A classe is-selected existe porque o CSS usa :has() para o estado marcado, e
     :has() não chega a navegador antigo. Com a classe, o destaque funciona dos
     dois jeitos. */
  function select(root, tier) {
    var tiers = root.querySelectorAll('[data-cx-bn-tier]');
    for (var i = 0; i < tiers.length; i++) tiers[i].classList.remove('is-selected');
    if (tier) tier.classList.add('is-selected');

    var qty = num(tier, 'data-qty');
    if (!qty) return;

    syncPicker(root, qty);
    syncFirstRowToSwatch(root);
    repaint(root);

    // O campo de quantidade segue valendo para o combo de 1 unidade, que é o
    // caminho nativo. Com 2+ a adição é interceptada e o campo é ignorado —
    // mas mantê-lo coerente evita que outro ponto do tema leia um valor velho.
    var form = root.closest('form');
    if (!form) return;
    var qinput = form.querySelector('[data-qty-input]');
    if (!qinput) return;
    if (String(qinput.value) === String(qty)) return;
    qinput.value = qty;
    qinput.dispatchEvent(new Event('input', { bubbles: true }));
    qinput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bind(root) {
    if (root.dataset.bnBound === '1') return;
    root.dataset.bnBound = '1';

    root.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.classList || !input.classList.contains('cx-bn-card__input')) return;
      select(root, input.closest('[data-cx-bn-tier]'));
    });

    root.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-cx-bn-pick-select')) repaint(root);
    });

    // Estado inicial: respeita o degrau que veio marcado do Liquid.
    var checked = root.querySelector('.cx-bn-card__input:checked');
    if (checked) select(root, checked.closest('[data-cx-bn-tier]'));
    repaint(root);
  }

  /* ===================== Sugestões abaixo do botão =====================
     Cada card é independente: escolhe a cor e adiciona. Sem total próprio e sem
     botão concorrendo com o "Adicionar ao carrinho" da página. */

  function sugPrices(sel) {
    try { return JSON.parse(sel.getAttribute('data-prices') || '{}'); } catch (e) { return {}; }
  }

  function sugRepaint(card) {
    var sel = card.querySelector('[data-cx-bn-sug-variant]');
    var priceEl = card.querySelector('[data-cx-bn-sug-price]');
    if (!sel || !priceEl || !sel.getAttribute) return;
    var map = sugPrices(sel);
    var p = map[String(sel.value)];
    if (typeof p === 'number') priceEl.textContent = money(p);
  }

  function sugAdd(card) {
    var btn = card.querySelector('[data-cx-bn-sug-add]');
    var sel = card.querySelector('[data-cx-bn-sug-variant]');
    if (!btn || !sel || btn.dataset.busy === '1') return;
    var id = parseInt(sel.value, 10);
    if (!id) return;

    btn.dataset.busy = '1';
    btn.textContent = 'Adicionando...';

    function done(ok) {
      btn.dataset.busy = '';
      if (ok) {
        btn.textContent = 'Adicionado ✓';
        btn.classList.add('is-done');
        // volta ao rótulo normal para o cliente poder adicionar outra cor
        window.setTimeout(function () {
          btn.textContent = btn.getAttribute('data-label') || 'Adicionar';
          btn.classList.remove('is-done');
        }, 2200);
      } else {
        btn.textContent = btn.getAttribute('data-label') || 'Adicionar';
      }
    }

    // Mesmo cuidado do resto do arquivo: BoosterTheme é binding `let`, não
    // existe em window.
    try {
      if (typeof BoosterTheme !== 'undefined' && BoosterTheme.cart &&
          typeof BoosterTheme.cart.addToCartJSON === 'function') {
        BoosterTheme.cart.addToCartJSON(false, { items: [{ id: id, quantity: 1 }] });
        window.setTimeout(function () { done(true); }, 900);
        return;
      }
    } catch (e) {}

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function () { done(true); }).catch(function () { done(false); });
  }

  function sugBind(root) {
    if (root.dataset.bnSugBound === '1') return;
    root.dataset.bnSugBound = '1';

    root.addEventListener('change', function (e) {
      var card = e.target.closest && e.target.closest('[data-cx-bn-sug-card]');
      if (card && e.target.hasAttribute && e.target.hasAttribute('data-cx-bn-sug-variant')) sugRepaint(card);
    });

    root.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-cx-bn-sug-add]');
      if (!btn) return;
      e.preventDefault();
      sugAdd(btn.closest('[data-cx-bn-sug-card]'));
    });

    var cards = root.querySelectorAll('[data-cx-bn-sug-card]');
    for (var i = 0; i < cards.length; i++) sugRepaint(cards[i]);
  }

  function initSug(scope) {
    var roots = (scope || document).querySelectorAll('[data-cx-bn-sug]');
    for (var i = 0; i < roots.length; i++) sugBind(roots[i]);
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-cx-bn-tiers]');
    for (var i = 0; i < roots.length; i++) bind(roots[i]);
    initSug(scope);
  }

  function repaintAll() {
    var roots = document.querySelectorAll('[data-cx-bn-tiers]');
    for (var i = 0; i < roots.length; i++) repaint(roots[i]);
  }

  /* ---------- Entrega do combo ao carrinho ----------
     Com 2+ unidades as cores podem divergir, então o campo de quantidade não
     serve: 3 unidades podem ser 3 variantes diferentes.

     O tema dispara 'booster:cart:b*add' como CustomEvent cancelável antes de
     adicionar (cancelável porque o nome contém ':b*' — ver BstrEvents.trigger
     no booster.js: ele usa o retorno de dispatchEvent como 'prevent'). Então
     preventDefault() aqui cancela a adição nativa pelo mecanismo do próprio
     tema, sem precisar mexer no botão nem no onclick.

     Só cancelamos quando conseguimos montar a lista. Qualquer falha deixa o
     fluxo nativo seguir: melhor adicionar 1 unidade do que travar o botão. */
  document.addEventListener('booster:cart:b*add', function (e) {
    try {
      var form = e.detail && e.detail.form;
      if (!form) return;
      var root = form.querySelector('[data-cx-bn-tiers]');
      if (!root) return;
      if (bypass) return;

      var items = comboItems(root);
      if (!items || !items.length) return;   // combo de 1 unidade: caminho nativo

      e.preventDefault();

      var target = e.detail && e.detail.target;
      var textEl = target && target.querySelector && target.querySelector('[data-button-text]');
      // O tema já trocou o texto para "Adicionando ao carrinho..." ANTES de
      // disparar este evento, e vai restaurá-lo logo depois de ver o cancelamento
      // (addToCart: on prevent, devolve target.dataset.originalText). Ler
      // textContent aqui pegaria justamente o "Adicionando...", que foi como o
      // botão ficou travado nesse texto na primeira versão. O rótulo bom é o que
      // o próprio tema guardou no atributo.
      var original = (target && target.getAttribute('data-original-text')) || null;

      function restore() {
        if (target) target.disabled = false;
        if (textEl && original !== null) textEl.textContent = original;
      }

      // Depois do restore do tema, não antes: o trigger é síncrono e o tema
      // reabilita o botão assim que vê o preventDefault.
      window.setTimeout(function () {
        if (target) target.disabled = true;
        if (textEl) textEl.textContent = 'Adicionando...';
      }, 0);

      if (typeof BoosterTheme !== 'undefined' && BoosterTheme.cart &&
          typeof BoosterTheme.cart.addToCartJSON === 'function') {
        bypass = true;
        try { BoosterTheme.cart.addToCartJSON(false, { items: items }); }
        finally { bypass = false; }
        window.setTimeout(restore, 1200);
        return;
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function () { window.location.reload(); }).catch(restore);
    } catch (err) {
      // Deixa o tema seguir: um erro aqui não pode impedir a compra.
    }
  }, false);

  window.EthosBN = { init: init, repaint: repaintAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Troca de variante pelos swatches: o tema reescreve o input da variante e
  // dispara estes eventos. Sem isso o preço da escada ficaria no da variante
  // anterior.
  document.addEventListener('booster:swatch:update', repaintAll);
  document.addEventListener('booster:swatch:render', function () { init(); repaintAll(); });
  document.addEventListener('booster:content:update', function () { init(); repaintAll(); });
})();
